(function () {
  "use strict";

  var CLASS_V1 = "ab-free-shipping-v1";
  var CLASS_V2 = "ab-free-shipping-v2";
  var CLASS_CURRENCY = "ab-free-shipping-with-currency";
  var CUSTOM_ID = "ab-upcart-rewards";
  var STYLE_ID = "ab-upcart-rewards-style";
  var USD_V1 = 75;
  var USD_V2 = 85;
  var USD_GIFTS = 0;
  var COLOR_ACCENT = "rgb(90, 118, 132)";
  var COLOR_TRACK = "rgb(241, 244, 245)";

  var observer = null;
  var pendingStructure = false;
  var pendingCartRefresh = false;
  var cartFetchInFlight = null;
  var lastCart = null;
  var suppressObserver = false;
  var stylesInjected = false;

  function getConfig() {
    return window.FREE_SHIPPING_THRESHOLD || {};
  }

  function getVariant() {
    var html = document.documentElement;
    if (html.classList.contains(CLASS_V2)) return "v2";
    if (html.classList.contains(CLASS_V1)) return "v1";
    return null;
  }

  /* Intelligems opt-in: only FX + local symbols when this class is present. */
  function shouldConvertCurrency() {
    return document.documentElement.classList.contains(CLASS_CURRENCY);
  }

  function getUpcartDoc() {
    return window.upcartDocumentOrShadowRoot || document;
  }

  function injectStyles() {
    var css =
      "#" +
      CUSTOM_ID +
      "{" +
      "box-sizing:border-box;" +
      "width:100%;" +
      "font-size:15px;" +
      "line-height:20px;" +
      "padding:18px 30px 5px;" +
      "text-align:center;" +
      "color:#121212;" +
      "font-family:inherit;" +
      "}" +
      "#" +
      CUSTOM_ID +
      " .ab-upcart-rewards__message{margin:0;}" +
      "#" +
      CUSTOM_ID +
      " .ab-upcart-rewards__message p{margin:0;font-size:15px;line-height:20px;font-weight:400;}" +
      "#" +
      CUSTOM_ID +
      " .ab-upcart-rewards__bar{" +
      "background:" +
      COLOR_TRACK +
      ";" +
      "border-radius:16px;" +
      "height:10px;" +
      "margin-top:22.5px;" +
      "overflow:hidden;" +
      "width:100%;" +
      "}" +
      "#" +
      CUSTOM_ID +
      " .ab-upcart-rewards__fill{" +
      "background:" +
      COLOR_ACCENT +
      ";" +
      "height:100%;" +
      "width:0;" +
      "border-radius:16px;" +
      "transition:width .35s ease;" +
      "}" +
      "#" +
      CUSTOM_ID +
      " .ab-upcart-rewards__tiers{" +
      "display:flex;" +
      "justify-content:space-between;" +
      "margin-top:-25px;" +
      "}" +
      "#" +
      CUSTOM_ID +
      " .ab-upcart-rewards__tier{" +
      "align-items:center;" +
      "display:flex;" +
      "flex-direction:column;" +
      "max-height:100px;" +
      "max-width:75px;" +
      "min-width:75px;" +
      "width:75px;" +
      "}" +
      "#" +
      CUSTOM_ID +
      " .ab-upcart-rewards__spacer{" +
      "min-width:75px;" +
      "width:75px;" +
      "}" +
      "#" +
      CUSTOM_ID +
      " .ab-upcart-rewards__circle{" +
      "border-radius:50%;" +
      "display:flex;" +
      "align-items:center;" +
      "justify-content:center;" +
      "height:40px;" +
      "width:40px;" +
      "margin-left:2.5px;" +
      "margin-right:2.5px;" +
      "box-sizing:border-box;" +
      "}" +
      "#" +
      CUSTOM_ID +
      " .ab-upcart-rewards__icon{" +
      "width:25px;" +
      "height:25px;" +
      "margin:auto;" +
      "display:flex;" +
      "align-items:center;" +
      "justify-content:center;" +
      "}" +
      "#" +
      CUSTOM_ID +
      " .ab-upcart-rewards__icon svg{" +
      "width:25px;" +
      "height:25px;" +
      "display:block;" +
      "}" +
      "#" +
      CUSTOM_ID +
      " .ab-upcart-rewards__label," +
      "#" +
      CUSTOM_ID +
      " .upcart-rewards-tier-description{" +
      "word-wrap:normal;" +
      "font-size:x-small;" +
      "line-height:1.25;" +
      "margin-top:5px;" +
      "font-weight:400;" +
      "color:#121212;" +
      "white-space:nowrap;" +
      "}";

    function appendOrReplace(target) {
      if (!target) return;
      var host = target.head || target;
      var existing =
        (host.getElementById && host.getElementById(STYLE_ID)) ||
        (target.querySelector && target.querySelector("#" + STYLE_ID));
      if (existing) {
        existing.textContent = css;
        return;
      }
      var style = document.createElement("style");
      style.id = STYLE_ID;
      style.textContent = css;
      if (host.appendChild) host.appendChild(style);
      else target.appendChild(style);
    }

    appendOrReplace(document);
    try {
      var udoc = getUpcartDoc();
      if (udoc && udoc !== document) appendOrReplace(udoc);
    } catch (e) {}

    stylesInjected = true;
  }

  function getCartRoot() {
    var doc = getUpcartDoc();
    return (
      doc.querySelector(
        '#UpcartPopup, #CartPopup, upcart-drawer, #upcart-drawer, .upcart-drawer, #upCart, .upcart-cart, [class*="upcart-cart"]',
      ) || null
    );
  }

  function stripHtml(value) {
    var el = document.createElement("div");
    el.innerHTML = value;
    return (el.textContent || "").trim();
  }

  function getActiveCurrency() {
    var cfg = getConfig();
    if (window.Shopify && Shopify.currency && Shopify.currency.active) {
      return String(Shopify.currency.active).toUpperCase();
    }
    return String(cfg.activeCurrency || cfg.shopCurrency || "USD").toUpperCase();
  }

  function formatMoney(cents) {
    var cfg = getConfig();
    /* `cents` are in presentment (same units as cart / threshold math).
       Currency class only changes how we print them — not the bar math. */
    var convert = shouldConvertCurrency();
    var displayCents = cents;
    var currency = "USD";

    if (convert) {
      currency = getActiveCurrency();
    } else {
      /* Show USD labels: convert presentment cents back to USD when rate applies. */
      var rate = getCurrencyRate();
      var active = getActiveCurrency();
      var shopCurrency = getShopCurrency();
      if (
        !(shopCurrency === "USD" && active === "USD") &&
        rate &&
        Math.abs(rate - 1) >= 0.0001
      ) {
        displayCents = Math.round(cents / rate);
      }
      currency = "USD";
    }

    var amount = (Math.max(0, displayCents) / 100).toFixed(2);
    var amountNoDecimals = String(Math.round(Math.max(0, displayCents) / 100));
    var moneyFormat = convert
      ? cfg.moneyFormat || "${{amount}}"
      : "${{amount}}";

    if (window.Shopify && typeof Shopify.formatMoney === "function") {
      var formatted = stripHtml(Shopify.formatMoney(displayCents, moneyFormat));
      if (!convert) {
        if (formatted.indexOf("$") === -1) {
          return "$" + amount;
        }
        return formatted;
      }
      /* If shop money format is still $, but presentment isn't USD, use local symbol. */
      if (currency !== "USD" && formatted.indexOf("$") !== -1) {
        var whole = Math.round(Math.max(0, displayCents) / 100);
        var symbols = {
          EUR: "€",
          GBP: "£",
          CAD: "CA$",
          AUD: "A$",
          NZD: "NZ$",
          INR: "₹",
          JPY: "¥",
          SGD: "S$",
          HKD: "HK$",
          MXN: "MX$",
        };
        var symbol = symbols[currency];
        if (symbol) {
          var decimal = (Math.max(0, displayCents) / 100)
            .toFixed(currency === "JPY" ? 0 : 2)
            .replace(".", ",");
          return symbol + decimal;
        }
        return whole + " " + currency;
      }
      return formatted;
    }

    var fallback = String(moneyFormat)
      .replace(
        /\{\{\s*amount_with_comma_separator\s*\}\}/g,
        amount.replace(".", ","),
      )
      .replace(
        /\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g,
        amountNoDecimals.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
      )
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)
      .replace(/\{\{\s*amount\s*\}\}/g, amount);

    return stripHtml(fallback);
  }

  function getCurrencyRate() {
    if (window.Shopify && Shopify.currency && Shopify.currency.rate != null) {
      var rate = parseFloat(Shopify.currency.rate);
      if (!isNaN(rate) && rate > 0) return rate;
    }
    return 1;
  }

  function getShopCurrency() {
    var cfg = getConfig();
    return String(cfg.shopCurrency || "USD").toUpperCase();
  }

  function usdToLocalCents(usd) {
    /* Always match cart presentment for progress math. Display class does not gate this. */
    var rate = getCurrencyRate();
    var shopCurrency = getShopCurrency();
    var active =
      window.Shopify && Shopify.currency && Shopify.currency.active
        ? String(Shopify.currency.active).toUpperCase()
        : String(getConfig().activeCurrency || shopCurrency).toUpperCase();

    if (shopCurrency === "USD" && active === "USD") {
      return Math.round(Number(usd) * 100);
    }

    return Math.round(Number(usd) * rate * 100);
  }

  function getShippingThresholdUsd(variant) {
    return variant === "v2" ? USD_V2 : USD_V1;
  }

  function isFreeGiftItem(item) {
    if (!item) return false;
    if (item.final_price === 0 && item.original_price === 0) return true;
    var properties = item.properties || {};
    if (
      properties._free_product === true ||
      properties._free_product === "true"
    )
      return true;
    return false;
  }

  function normalizeMoneyToCents(value) {
    if (typeof value !== "number" || isNaN(value) || value <= 0) return 0;
    /* Shopify cart.js uses integer cents. UpCart may expose major units (51.95). */
    if (Math.abs(value - Math.round(value)) > 0.001) {
      return Math.round(value * 100);
    }
    return Math.round(value);
  }

  function getItemLineCents(item) {
    if (!item) return 0;
    var raw =
      item.final_line_price != null
        ? item.final_line_price
        : item.line_price != null
          ? item.line_price
          : item.final_price != null
            ? item.final_price * (item.quantity || 1)
            : item.price != null
              ? item.price * (item.quantity || 1)
              : 0;
    return normalizeMoneyToCents(Number(raw) || 0);
  }

  function getCartProgressCents(cart) {
    if (!cart) return 0;

    var direct = [
      cart.total_price,
      cart.items_subtotal_price,
      cart.total,
      cart.subtotal,
      cart.cartTotal,
    ];

    for (var i = 0; i < direct.length; i++) {
      var cents = normalizeMoneyToCents(Number(direct[i]));
      /* Ignore explicit zeros so we can fall through to item sums / better fields. */
      if (cents > 0) return cents;
    }

    if (!cart.items || !cart.items.length) return 0;

    var total = 0;
    cart.items.forEach(function (item) {
      if (isFreeGiftItem(item)) return;
      total += getItemLineCents(item);
    });
    return Math.max(0, total);
  }

  function getUpcartLiveCart() {
    if (typeof window.upcartGetCart === "function") {
      try {
        var live = window.upcartGetCart();
        if (live) return live;
      } catch (e) {}
    }
    return null;
  }

  function fetchCart() {
    if (cartFetchInFlight) return cartFetchInFlight;

    cartFetchInFlight = fetch("/cart.js", { credentials: "same-origin" })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        if (cart) lastCart = cart;
        return cart;
      })
      .catch(function () {
        var live = getUpcartLiveCart();
        if (live) {
          lastCart = live;
          return live;
        }
        return lastCart;
      })
      .finally(function () {
        cartFetchInFlight = null;
      });

    return cartFetchInFlight;
  }

  function resolveCart(preferNetwork) {
    if (!preferNetwork) {
      var live = getUpcartLiveCart();
      if (live) {
        lastCart = live;
        return Promise.resolve(live);
      }
      if (lastCart) return Promise.resolve(lastCart);
    }
    return fetchCart();
  }

  function buildMessage(progressCents, shippingCents) {
    if (progressCents >= shippingCents) {
      return "Yay! You've unlocked all the rewards! \uD83C\uDF81";
    }
    var remaining = Math.max(0, shippingCents - progressCents);
    return "You're " + formatMoney(remaining) + " away from free shipping!";
  }

  function giftIconSvg() {
    return (
      '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false">' +
      '<path fill-rule="evenodd" d="M8.798 7.992c-.343-.756-1.098-1.242-1.928-1.242-1.173 0-2.119.954-2.119 2.122 0 1.171.95 2.128 2.125 2.128h.858c-.595.51-1.256.924-1.84 1.008-.41.058-.694.438-.635.848.058.41.438.695.848.636 1.11-.158 2.128-.919 2.803-1.53.121-.11.235-.217.341-.322.106.105.22.213.34.322.676.611 1.693 1.372 2.804 1.53.41.059.79-.226.848-.636.059-.41-.226-.79-.636-.848-.583-.084-1.244-.498-1.839-1.008h.858c1.176 0 2.125-.957 2.125-2.128 0-1.168-.946-2.122-2.119-2.122-.83 0-1.585.486-1.928 1.242l-.453.996-.453-.996Zm-.962 1.508h-.96c-.343 0-.625-.28-.625-.628 0-.344.28-.622.619-.622.242 0 .462.142.563.363l.403.887Zm3.79 0h-.96l.403-.887c.1-.221.32-.363.563-.363.34 0 .619.278.619.622 0 .347-.282.628-.625.628Z"></path>' +
      '<path fill-rule="evenodd" d="M2.499 6.75c0-1.519 1.231-2.75 2.75-2.75h9.5c1.519 0 2.75 1.231 2.75 2.75v2.945l.002.055c0 .018 0 .037-.002.055v3.445c0 1.519-1.231 2.75-2.75 2.75h-9.5c-1.519 0-2.75-1.231-2.75-2.75v-6.5Zm13.5 2.25h-1.248c-.414 0-.75.336-.75.75s.336.75.75.75h1.248v2.75c0 .69-.56 1.25-1.25 1.25h-4.748v-1c0-.414-.336-.75-.75-.75s-.75.336-.75.75v1h-3.252c-.69 0-1.25-.56-1.25-1.25v-2.792c.292-.102.502-.38.502-.708 0-.327-.21-.606-.502-.708v-2.292c0-.69.56-1.25 1.25-1.25h3.252v.75c0 .414.336.75.75.75s.75-.336.75-.75v-.75h4.748c.69 0 1.25.56 1.25 1.25v2.25Z"></path>' +
      "</svg>"
    );
  }

  function truckIconSvg() {
    return (
      '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false">' +
      '<path fill-rule="evenodd" d="M4 5.25a.75.75 0 0 1 .75-.75h6.991a2.75 2.75 0 0 1 2.645 1.995l.427 1.494a.25.25 0 0 0 .18.173l1.681.421a1.75 1.75 0 0 1 1.326 1.698v1.219a1.75 1.75 0 0 1-1.032 1.597 2.5 2.5 0 1 1-4.955.153h-3.025a2.5 2.5 0 1 1-4.78-.75h-.458a.75.75 0 0 1 0-1.5h2.5c.03 0 .06.002.088.005a2.493 2.493 0 0 1 1.947.745h4.43a2.493 2.493 0 0 1 1.785-.75c.698 0 1.33.286 1.783.748a.25.25 0 0 0 .217-.248v-1.22a.25.25 0 0 0-.19-.242l-1.682-.42a1.75 1.75 0 0 1-1.258-1.217l-.427-1.494a1.25 1.25 0 0 0-1.202-.907h-6.991a.75.75 0 0 1-.75-.75Zm2.5 9.25a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm8 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"></path>' +
      '<path d="M3.25 8a.75.75 0 0 0 0 1.5h5a.75.75 0 0 0 0-1.5h-5Z"></path>' +
      "</svg>"
    );
  }

  function ensureCustomBar(root) {
    var existing = root.querySelector("#" + CUSTOM_ID);
    if (existing) return existing;

    var native = root.querySelector(".upcart-rewards, .upcart-public-rewards");
    var bar = document.createElement("div");
    bar.id = CUSTOM_ID;
    bar.className = "ab-upcart-rewards upcart-rewards is-active";
    bar.setAttribute("aria-live", "polite");
    bar.innerHTML =
      '<div class="ab-upcart-rewards__message upcart-rewards-message"><p></p></div>' +
      '<div class="ab-upcart-rewards__bar upcart-rewards-bar-background" style="background-color:' +
      COLOR_TRACK +
      ';">' +
      '<div class="ab-upcart-rewards__fill upcart-rewards-bar-foreground" style="background-color:' +
      COLOR_ACCENT +
      ';width:0%;"></div>' +
      "</div>" +
      '<div class="ab-upcart-rewards__tiers">' +
      '<div class="ab-upcart-rewards__spacer"></div>' +
      '<div class="ab-upcart-rewards__tier ab-upcart-rewards__tier--gifts" data-tier="gifts">' +
      '<div class="ab-upcart-rewards__circle upcart-rewards-tier-circle">' +
      '<div class="ab-upcart-rewards__icon upcart-rewards-tier-icon">' +
      giftIconSvg() +
      "</div></div>" +
      '<div class="ab-upcart-rewards__label upcart-rewards-tier-description">Free Gifts</div>' +
      "</div>" +
      '<div class="ab-upcart-rewards__tier ab-upcart-rewards__tier--shipping" data-tier="shipping">' +
      '<div class="ab-upcart-rewards__circle upcart-rewards-tier-circle">' +
      '<div class="ab-upcart-rewards__icon upcart-rewards-tier-icon">' +
      truckIconSvg() +
      "</div></div>" +
      '<div class="ab-upcart-rewards__label upcart-rewards-tier-description">Free Shipping</div>' +
      "</div>" +
      "</div>";

    if (native && native.parentNode) {
      native.parentNode.insertBefore(bar, native);
    } else {
      var body =
        root.querySelector('.upcart-cart-body, [class*="CartPreview__body"]') ||
        root;
      body.insertBefore(bar, body.firstChild);
    }

    return bar;
  }

  function setNativeRewardsHidden(root, hidden) {
    root
      .querySelectorAll(".upcart-rewards, .upcart-public-rewards")
      .forEach(function (node) {
        if (node.id === CUSTOM_ID) return;
        if (hidden) {
          node.setAttribute("data-ab-rewards-hidden", "true");
          node.style.setProperty("display", "none", "important");
        } else if (node.getAttribute("data-ab-rewards-hidden") === "true") {
          node.removeAttribute("data-ab-rewards-hidden");
          node.style.removeProperty("display");
        }
      });
  }

  function removeCustomBar(root) {
    var existing = root.querySelector("#" + CUSTOM_ID);
    if (existing) existing.remove();
  }

  function setTierComplete(tierEl, complete) {
    if (!tierEl) return;
    var circle = tierEl.querySelector(".ab-upcart-rewards__circle");
    if (!circle) return;

    tierEl.classList.toggle("is-complete", complete);

    if (complete) {
      circle.style.backgroundColor = COLOR_ACCENT;
      circle.style.border = "none";
      circle.style.fill = COLOR_TRACK;
      circle.querySelectorAll("path").forEach(function (path) {
        path.setAttribute("fill", COLOR_TRACK);
      });
    } else {
      circle.style.backgroundColor = COLOR_TRACK;
      circle.style.border = "2px solid " + COLOR_ACCENT;
      circle.style.fill = COLOR_ACCENT;
      circle.querySelectorAll("path").forEach(function (path) {
        path.setAttribute("fill", COLOR_ACCENT);
      });
    }
  }

  function isCartEmpty(cart) {
    if (!cart) return true;
    if (typeof cart.item_count === "number" && cart.item_count <= 0) return true;
    if (!cart.items || !cart.items.length) return true;
    return false;
  }

  function isEmptyCartUi(root) {
    if (!root) return false;
    if (
      root.querySelector(
        '.upcart-empty-cart, .upcart-cart-empty, [class*="EmptyCart"], [class*="empty-cart"], [class*="EmptyState"]',
      )
    ) {
      return true;
    }
    var body =
      root.querySelector('.upcart-cart-body, [class*="CartPreview__body"]') ||
      root;
    var text = body.innerText || body.textContent || "";
    return /nothing here yet/i.test(text);
  }

  function shouldShowCustomBar(root, cart) {
    if (cart) return !isCartEmpty(cart);
    return !isEmptyCartUi(root);
  }

  function hideRewardsForEmpty(root) {
    if (!root) return;
    removeCustomBar(root);
    setNativeRewardsHidden(root, true);
  }

  function updateBar(bar, cart, variant) {
    if (!bar || !cart || !variant) return;

    suppressObserver = true;
    try {
      var shippingUsd = getShippingThresholdUsd(variant);
      var giftsCents = usdToLocalCents(USD_GIFTS);
      var shippingCents = usdToLocalCents(shippingUsd);
      var progressCents = getCartProgressCents(cart);
      var fillPct =
        shippingCents > 0
          ? Math.min(100, (progressCents / shippingCents) * 100)
          : 0;

      var giftsDone = progressCents >= giftsCents;
      var shippingDone = progressCents >= shippingCents;
      var message = buildMessage(progressCents, shippingCents);

      var messageEl = bar.querySelector(".ab-upcart-rewards__message p");
      var fillEl = bar.querySelector(".ab-upcart-rewards__fill");
      var giftsTier = bar.querySelector(".ab-upcart-rewards__tier--gifts");
      var shippingTier = bar.querySelector(
        ".ab-upcart-rewards__tier--shipping",
      );

      if (messageEl) messageEl.textContent = message;
      if (fillEl) fillEl.style.width = fillPct.toFixed(4) + "%";
      setTierComplete(giftsTier, giftsDone);
      setTierComplete(shippingTier, shippingDone);
    } finally {
      /* Let UpCart finish its own DOM paint before we listen again. */
      setTimeout(function () {
        suppressObserver = false;
      }, 0);
    }
  }

  /* DOM-only: keep custom bar mounted. Never hit /cart.js here — qty changes
     already mutate the drawer heavily; network fetches competed with UpCart. */
  function applyStructure() {
    pendingStructure = false;
    injectStyles();

    var variant = getVariant();
    var root = getCartRoot();
    if (!root) return null;

    if (!variant) {
      removeCustomBar(root);
      setNativeRewardsHidden(root, false);
      return null;
    }

    var cached = getUpcartLiveCart() || lastCart;
    if (!shouldShowCustomBar(root, cached)) {
      hideRewardsForEmpty(root);
      return null;
    }

    if (
      !root.querySelector(
        ".upcart-rewards, .upcart-public-rewards, #" + CUSTOM_ID,
      )
    ) {
      /* Empty cart often has no native rewards node — still hide ours. */
      if (isEmptyCartUi(root) || (cached && isCartEmpty(cached))) {
        hideRewardsForEmpty(root);
      }
      return null;
    }

    suppressObserver = true;
    var bar;
    try {
      setNativeRewardsHidden(root, true);
      bar = ensureCustomBar(root);
      bar.classList.add("is-active");
    } finally {
      setTimeout(function () {
        suppressObserver = false;
      }, 0);
    }

    if (cached) updateBar(bar, cached, variant);
    return bar;
  }

  function applyCartRefresh(preferNetwork) {
    pendingCartRefresh = false;
    var variant = getVariant();
    var root = getCartRoot();
    if (!variant || !root) {
      applyStructure();
      return;
    }

    resolveCart(!!preferNetwork).then(function (cart) {
      if (!getVariant()) return;
      var liveRoot = getCartRoot();
      if (!liveRoot) return;

      if (!shouldShowCustomBar(liveRoot, cart)) {
        hideRewardsForEmpty(liveRoot);
        return;
      }

      var bar = applyStructure();
      if (!bar || !cart) return;
      var liveBar = liveRoot.querySelector("#" + CUSTOM_ID);
      if (!liveBar) return;
      updateBar(liveBar, cart, variant);
    });
  }

  function scheduleStructure() {
    if (pendingStructure) return;
    pendingStructure = true;
    if (typeof requestAnimationFrame === "function") {
      requestAnimationFrame(applyStructure);
    } else {
      setTimeout(applyStructure, 16);
    }
  }

  function scheduleCartRefresh(preferNetwork) {
    if (pendingCartRefresh) return;
    pendingCartRefresh = true;
    setTimeout(function () {
      applyCartRefresh(preferNetwork);
    }, preferNetwork ? 180 : 120);
  }

  function subscribeUpcart() {
    [
      "upcartSubscribeCartOpened",
      "upcartSubscribeCartLoaded",
      "upcartSubscribeCartUpdated",
      "upcartSubscribeAddedToCart",
      "upcartSubscribeItemRemoved",
    ].forEach(function (name) {
      if (typeof window[name] === "function") {
        try {
          window[name](function () {
            /* Real cart changes: one coalesced network refresh, not per DOM tick. */
            scheduleCartRefresh(true);
          });
        } catch (e) {}
      }
    });
  }

  /* Qty +/- in the drawer often skips UpCart subscribe hooks. Catch the Shopify
     cart requests themselves and refresh totals once (coalesced). */
  function interceptCartFetch() {
    if (window.__abUpcartRewardsFetchPatched) return;
    window.__abUpcartRewardsFetchPatched = true;

    var previousFetch = window.fetch;
    window.fetch = function () {
      var firstArg = arguments[0];
      var url =
        typeof firstArg === "string"
          ? firstArg
          : firstArg && firstArg.url
            ? firstArg.url
            : "";

      return previousFetch.apply(this, arguments).then(function (response) {
        if (
          typeof url === "string" &&
          /\/cart\/(?:add|change|update|clear)(?:\.js)?(?:[?#]|$)/.test(url)
        ) {
          lastCart = null;
          if (getVariant()) scheduleCartRefresh(true);
        }
        return response;
      });
    };
  }

  function mutationNeedsStructure(mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      if (m.type === "attributes") return true;

      var nodes = [];
      if (m.addedNodes && m.addedNodes.length) {
        for (var a = 0; a < m.addedNodes.length; a++) nodes.push(m.addedNodes[a]);
      }
      if (m.removedNodes && m.removedNodes.length) {
        for (var r = 0; r < m.removedNodes.length; r++)
          nodes.push(m.removedNodes[r]);
      }

      for (var n = 0; n < nodes.length; n++) {
        var node = nodes[n];
        if (!node || node.nodeType !== 1) continue;
        if (node.id === CUSTOM_ID || (node.closest && node.closest("#" + CUSTOM_ID)))
          continue;
        if (
          (node.matches &&
            node.matches(
              ".upcart-rewards, .upcart-public-rewards, #UpcartPopup, #CartPopup, upcart-drawer, .upcart-drawer, .upcart-cart, .upcart-empty-cart, .upcart-cart-empty, [class*='EmptyCart'], [class*='empty-cart']",
            )) ||
          (node.querySelector &&
            node.querySelector(
              ".upcart-rewards, .upcart-public-rewards, #" +
                CUSTOM_ID +
                ", .upcart-empty-cart, .upcart-cart-empty, [class*='EmptyCart'], [class*='empty-cart']",
            ))
        ) {
          return true;
        }
      }
    }
    return false;
  }

  function startObserver() {
    if (observer) return;

    observer = new MutationObserver(function (mutations) {
      if (suppressObserver) return;
      if (!getVariant()) {
        scheduleStructure();
        return;
      }
      if (mutationNeedsStructure(mutations)) scheduleStructure();
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["class"],
    });

    var doc = getUpcartDoc();
    var root = doc.body || doc.documentElement || document.body;
    if (root) {
      observer.observe(root, { childList: true, subtree: true });
    }
  }

  function init() {
    subscribeUpcart();
    interceptCartFetch();
    startObserver();
    scheduleCartRefresh(true);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
